interface LabelBusinessMaxProps {
  label: string;
}

export const LabelBusinessMax = ({ label }: LabelBusinessMaxProps) => {
  return (
    <label
      className="nj-label-free nj-label-superninja-ultra"
      data-e2e="label-tier-teams-max"
    >
      {`Business ${label}`}
    </label>
  );
};
